import { workerVisitLockWorkerContract } from "@clipboard-health/contract-home-health-api";
import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

interface UseGetWorkerLockStatusParams {
  workerId: string;
  workplaceId: string;
  enabled?: boolean;
}

export function useGetWorkerLockStatus(params: UseGetWorkerLockStatusParams) {
  const { workerId, workplaceId, enabled } = params;

  const url = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/${workerId}/visit-lock`;

  const query = useGetParsedQuery({
    url,
    responseSchema: workerVisitLockWorkerContract.getWorkerVisitLock.responses[200],
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_LOCK_STATUS_FAILURE },
    enabled,
  });

  const lockData = query.data?.data ?? null;
  const isLocked = lockData !== null;
  const lockedByCurrentWorkplace =
    isLocked && lockData.attributes.lockedByWorkplaceId === workplaceId;

  return {
    ...query,
    lockData,
    isLocked,
    lockedByCurrentWorkplace,
  };
}
